module.exports = __webpack_public_path__ + "static/img/M1.e97f03d9.png";